import { Chip } from "@mui/material";
import { RESERVATION_STATUS, RESERVATION_STATUS_LABELS } from "../../../../common/enums";

const getReservationStatusColor = (status) => {
    switch (status) {
        case RESERVATION_STATUS.CONFIRMED:
            return 'success';
        case RESERVATION_STATUS.CANCELLED:
            return 'error';
        default:
            return 'default';
    }
};

const ReservationStatus = ({ status }) => {
    if (!status) return null;
    const label = RESERVATION_STATUS_LABELS[status] ?? status;
    return (
        <Chip
            sx={{ margin: '0px 20px', fontWeight: 500 }}
            label={label}
            color={getReservationStatusColor(status)}
        />
    );
};

export default ReservationStatus;
